import { getDataMapper, mapField } from "@/shared";

export const mapRepairProductToServer = getDataMapper(
    {
        product_id: mapField("product", (p) => p.id),
        count: mapField("count", Number),
    },
    { shouldAvoidUndefined: true }
);
